import React, { useRef } from 'react';
import map from 'lodash/map';

import { CarouselSection } from 'shared-components/carousel/CarouselSection';
import { CarouselSectionArrow } from 'shared-components/carousel/CarouselSectionArrow';
import { useCarouselArrows } from 'shared-components/carousel/utils/use-carousel-arrows';

import { CateringPackageSlide } from './CateringLandingPackageSlide';

export const CateringLandingPackageSection = ({ id, backgroundColor, title, subheader, packages, navigation }) => {
  const sliderRef = useRef(null);
  const { arrowDisabled, displayArrows, handleBeforeChange, onReInit } = useCarouselArrows(sliderRef);

  return (
    <section
      id={id}
      className="catering-landing-package-section"
      style={{ backgroundColor: backgroundColor }}
    >
      <CarouselSection
        ref={sliderRef}
        onReInit={onReInit}
        beforeChange={handleBeforeChange}
        header={
          <div className="margin-lg-bottom flex space-between" style={{ gap: 8 }}>
            <h3 className="no-margin tw-headline-5-b">{title}</h3>
          </div>
        }
        subheader={
          <p
            className="no-margin tw-body-4"
            style={{ maxWidth: '576px', marginBottom: '40px' }}
          >
            {subheader}
          </p>
        }
        footer={
          displayArrows && (
            <div className="flex space-between middle tw-mt-32">
              <CarouselSectionArrow
                sliderRef={sliderRef}
                direction="left"
                disabled={arrowDisabled.left}
              />
              <CarouselSectionArrow
                sliderRef={sliderRef}
                direction="right"
                disabled={arrowDisabled.right}
              />
            </div>
          )
        }
      >
        {map(packages, (cateringPackage) => (
          <CateringPackageSlide key={cateringPackage.id} {...cateringPackage} />
        ))}
      </CarouselSection>
    </section>
  );
};
